'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _zlib = require('zlib');

var _zlib2 = _interopRequireDefault(_zlib);

var _chunkstream = require('../chunkstream');

var _chunkstream2 = _interopRequireDefault(_chunkstream);

var _filter = require('../filter');

var _dataToBitMap = require('../dataToBitMap');

var _dataToBitMap2 = _interopRequireDefault(_dataToBitMap);

var _formatNormaliser = require('../format-normaliser');

var _formatNormaliser2 = _interopRequireDefault(_formatNormaliser);

var _parser = require('./parser');

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ParserAsync = function (_ChunkStream) {
  _inherits(ParserAsync, _ChunkStream);

  function ParserAsync(options) {
    _classCallCheck(this, ParserAsync);

    var _this = _possibleConstructorReturn(this, (ParserAsync.__proto__ || Object.getPrototypeOf(ParserAsync)).call(this, options));

    _this._parser = new _parser2.default(options, {
      read: _this.read.bind(_this),
      error: _this._handleError.bind(_this),
      metadata: _this._handleMetaData.bind(_this),
      gamma: _this.emit.bind(_this, 'gamma'),
      palette: _this._handlePalette.bind(_this),
      transColor: _this._handleTransColor.bind(_this),
      finished: _this._finished.bind(_this),
      inflateData: _this._inflateData.bind(_this)
    });
    _this._options = options;
    _this.writable = true;

    _this._parser.start();
    return _this;
  }

  _createClass(ParserAsync, [{
    key: '_handleError',
    value: function _handleError(err) {

      this.emit('error', err);

      this.writable = false;

      this.destroy();

      if (this._inflate && this._inflate.destroy) {
        this._inflate.destroy();
      }

      this.errord = true;
    }
  }, {
    key: '_inflateData',
    value: function _inflateData(data) {
      if (!this._inflate) {
        if (this._bitmapInfo.interlace) {
          this._inflate = _zlib2.default.createInflate();

          this._inflate.on('error', this.emit.bind(this, 'error'));
          this._filter.on('complete', this._complete.bind(this));

          this._inflate.pipe(this._filter);
        } else {
          var rowSize = (this._bitmapInfo.width * this._bitmapInfo.bpp * this._bitmapInfo.depth + 7 >> 3) + 1;
          var imageSize = rowSize * this._bitmapInfo.height;
          var chunkSize = Math.max(imageSize, _zlib2.default.Z_MIN_CHUNK);

          this._inflate = _zlib2.default.createInflate({ chunkSize: chunkSize });
          var leftToInflate = imageSize;

          var emitError = this.emit.bind(this, 'error');
          this._inflate.on('error', function (err) {
            if (!leftToInflate) {
              return;
            }

            emitError(err);
          });
          this._filter.on('complete', this._complete.bind(this));

          var filterWrite = this._filter.write.bind(this._filter);
          this._inflate.on('data', function (chunk) {
            if (!leftToInflate) {
              return;
            }

            if (chunk.length > leftToInflate) {
              chunk = chunk.slice(0, leftToInflate); // eslint-disable-line
            }

            leftToInflate -= chunk.length;

            filterWrite(chunk);
          });

          this._inflate.on('end', this._filter.end.bind(this._filter));
        }
      }
      this._inflate.write(data);
    }
  }, {
    key: '_handleMetaData',
    value: function _handleMetaData(metaData) {

      this.emit('metadata', metaData);

      this._bitmapInfo = Object.create(metaData);

      this._filter = new _filter.ParseAsync(this._bitmapInfo);
    }
  }, {
    key: '_handleTransColor',
    value: function _handleTransColor(transColor) {
      this._bitmapInfo.transColor = transColor;
    }
  }, {
    key: '_handlePalette',
    value: function _handlePalette(palette) {
      this._bitmapInfo.palette = palette;
    }
  }, {
    key: '_finished',
    value: function _finished() {
      if (this.errord) {
        return;
      }

      if (!this._inflate) {
        this.emit('error', 'No Inflate block');
      } else {
        // no more data to inflate
        this._inflate.end();
      }
      this.destroySoon();
    }
  }, {
    key: '_complete',
    value: function _complete(filteredData) {

      if (this.errord) {
        return;
      }

      try {
        var bitmapData = (0, _dataToBitMap2.default)(filteredData, this._bitmapInfo);

        var normalisedBitmapData = (0, _formatNormaliser2.default)(bitmapData, this._bitmapInfo, this._options.skipRescale);
        bitmapData = null;
      } catch (ex) {
        this._handleError(ex);
        return;
      }

      this.emit('parsed', normalisedBitmapData);
    }
  }]);

  return ParserAsync;
}(_chunkstream2.default);

exports.default = ParserAsync;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/parser/parser-async.js
// module id = 1066
// module chunks = 0